import { render, staticRenderFns } from "./jksxtgl.vue?vue&type=template&id=2717cfe0&scoped=true"
import script from "./jksxtgl.vue?vue&type=script&lang=js"
export * from "./jksxtgl.vue?vue&type=script&lang=js"
import style0 from "./jksxtgl.vue?vue&type=style&index=0&id=2717cfe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717cfe0",
  null
  
)

export default component.exports